import React from 'react';

import { Col, Container, Row, Card } from 'react-bootstrap';

import './error.scss';
import HttpHeader from 'src/Member/shared/httpheader';
const cName = HttpHeader.getCNAME();

//TODO: Re-factor the design
export default (props) => (
  <Container fluid>
    <Card className="mt-3 mb-3 p-5 card border-light">
      <Container className="mtop30 logout">
        <br />
        <br />
        <Row className="h-100">
          <Col className="my-auto error-container">
            <img
              id="tick-img"
              alt="Check Mark"
              src={require('../img/client-error.png')}
            />
            <Row className="mx-auto error-msg">
              <Col>
                <h1>Something went wrong with request!</h1>
                {cName.includes('mybenefits') ||
                cName.includes('roundstone') ? (
                  <>
                    <p>
                      {props.message ||
                        'Server request failed. Please contact support team.'}{' '}
                      <a href="mailto:portalsupport@choosebywater.com">
                        mailto:portalsupport@choosebywater.com
                      </a>
                    </p>
                  </>
                ) : (
                  <>
                    <p>
                      {props.message ||
                        'Server request failed. Please contact support team.'}{' '}
                      <a href="mailto:tpacustomerservice@keenan.com">
                        mailto:tpacustomerservice@keenan.com
                      </a>
                    </p>
                  </>
                )}
              </Col>
            </Row>
          </Col>
        </Row>
        <br />
        <br />
      </Container>
    </Card>
  </Container>
);
